import theme from 'theme';

const { colors, borders } = theme;

export const Button = {
  defaultProps: {
    variant: 'blue',
    style: {
      height: '44px',
      borderRadius: theme.radii.sm,
      fontSize: '12px',
    },
  },
  variants: [
    {
      props: { variant: 'blue' },
      style: {
        backgroundColor: colors.blue60,
        border: borders[0],
        borderColor: colors.blue60,
        color: '#fff',
        '&:hover': {
          backgroundColor: colors.blue60,
          borderColor: colors.blue60,
          color: '#fff',
        },
        '&:focus': {
          backgroundColor: colors.blue60,
          borderColor: colors.blue60,
          color: '#fff',
        },
        '&:disabled': {
          color: '#fff',
        },
      },
    },
    {
      props: { variant: 'white' },
      style: {
        backgroundColor: '#fff',
        color: colors.blue60,
        border: borders[0],
        borderColor: colors.blue20,
        '&:hover': {
          backgroundColor: '#fff',
          borderColor: colors.blue20,
          color: colors.blue60,
        },
        '&:focus': {
          backgroundColor: '#fff',
          borderColor: colors.blue20,
          color: colors.blue60,
        },
        '&:disabled': {
          color: colors.blue60,
        },
      },
    },
    {
      props: { variant: 'dashed' },
      style: {
        backgroundColor: '#fff',
        color: colors.berry60,
        borderColor: colors.berry60,
        border: borders[1],
        '&:hover': {
          backgroundColor: '#fff',
          borderColor: colors.berry60,
          color: colors.berry60,
        },
        '&:focus': {
          backgroundColor: '#fff',
          borderColor: colors.berry60,
          color: colors.berry60,
        },
        '&:disabled': {
          color: colors.berry60,
        },
      },
    },
    {
      props: { variant: 'berry' },
      style: {
        backgroundColor: '#fff',
        color: colors.berry60,
        borderColor: colors.berry60,
        border: borders[0],
        '&:hover': {
          backgroundColor: '#fff',
          borderColor: colors.berry60,
          color: colors.berry60,
        },
        '&:focus': {
          backgroundColor: '#fff',
          borderColor: colors.berry60,
          color: colors.berry60,
        },
        '&:disabled': {
          color: colors.berry60,
        },
      },
    },
    {
      props: { variant: 'lightBerry' },
      style: {
        backgroundColor: colors.berry10,
        color: colors.blue60,
        border: borders[0],
        borderColor: colors.berry10,
        '&:hover': {
          backgroundColor: colors.berry10,
          color: colors.blue60,
          border: borders[0],
          borderColor: colors.berry10,
        },
        '&:focus': {
          backgroundColor: colors.berry10,
          color: colors.blue60,
          border: borders[0],
          borderColor: colors.berry10,
        },
        '&:disabled': {
          color: colors.blue60,
        },
      },
    },
    {
      props: { variant: 'red' },
      style: {
        backgroundColor: colors.rose70,
        color: '#fff',
        borderColor: colors.rose70,
        border: borders[0],
        '&:hover': {
          backgroundColor: colors.rose70,
          borderColor: colors.rose70,
          color: '#fff',
        },
        '&:focus': {
          backgroundColor: colors.rose70,
          borderColor: colors.rose70,
          color: '#fff',
        },
        '&:disabled': {
          color: colors.rose80,
        },
      },
    },
    {
      props: { variant: 'green' },
      style: {
        backgroundColor: colors.aquamarine,
        color: '#fff',
        borderColor: colors.aquamarine,
        border: borders[0],
        '&:hover': {
          backgroundColor: colors.aquamarine,
          borderColor: colors.aquamarine,
          color: '#fff',
        },
        '&:focus': {
          backgroundColor: colors.aquamarine,
          borderColor: colors.aquamarine,
          color: '#fff',
        },
        '&:disabled': {
          color: '#fff',
        },
      },
    },
    {
      props: { variant: 'whiteText' },
      style: {
        backgroundColor: 'transparent',
        color: '#fff',
        '&:hover': {
          backgroundColor: 'transparent',
          color: '#fff',
        },
        '&:focus': {
          backgroundColor: 'transparent',
          color: '#fff',
        },
        '&:disabled': {
          color: '#fff',
        },
      },
    },
    {
      props: { variant: 'blueText' },
      style: {
        backgroundColor: 'transparent',
        color: colors.blue60,
        '&:hover': {
          backgroundColor: 'transparent',
          color: colors.blue60,
        },
        '&:focus': {
          backgroundColor: 'transparent',
          color: colors.blue60,
        },
        '&:disabled': {
          color: colors.blue60,
        },
      },
    },
    {
      props: { variant: 'redText' },
      style: {
        backgroundColor: 'transparent',
        color: colors.rose80,
        '&:hover': {
          backgroundColor: 'transparent',
          color: colors.rose80,
        },
        '&:focus': {
          backgroundColor: 'transparent',
          color: colors.rose80,
        },
        '&:disabled': {
          color: colors.rose80,
        },
      },
    },
    {
      props: { variant: 'lightBlue' },
      style: {
        backgroundColor: colors.berry60,
        color: '#fff',
        borderColor: 'transparent',
        border: borders[0],
        '&:hover': {
          backgroundColor: colors.berry60,
          borderColor: 'transparent',
          color: '#fff',
        },
        '&:focus': {
          backgroundColor: colors.berry60,
          borderColor: 'transparent',
          color: '#fff',
        },
        '&:disabled': {
          color: '#fff',
        },
      },
    },
    {
      props: { variant: 'transparent' },
      style: {
        backgroundColor: 'transparent',
        color: '#fff',
        borderColor: '#fff',
        border: borders[0],
        '&:hover': {
          backgroundColor: 'transparent',
          borderColor: '#fff',
          color: '#fff',
        },
        '&:focus': {
          backgroundColor: 'transparent',
          borderColor: '#fff',
          color: '#fff',
        },
        '&:disabled': {
          color: '#fff',
        },
      },
    },
    {
      props: { variant: 'danger' },
      style: {
        backgroundColor: 'transparent',
        color: colors.rose70,
        '&:hover': {
          backgroundColor: 'transparent',
          borderColor: 'transparent',
          color: colors.rose70,
        },
        '&:*': {
          backgroundColor: 'transparent',
          borderColor: 'transparent',
          color: colors.rose70,
        },
        '&:active': {
          backgroundColor: 'transparent',
          borderColor: 'transparent',
          color: colors.rose70,
        },
        '&:disabled': {
          color: colors.rose80,
        },
      },
    },
    {
      props: { variant: 'success' },
      style: {
        backgroundColor: 'transparent',
        color: colors.aquamarine,
        '&:hover': {
          backgroundColor: colors.rose80,
          borderColor: colors.mint,
          color: colors.mint,
        },
        '&:focus': {
          backgroundColor: '#fff',
          borderColor: '#fff',
          color: colors.mint,
        },
        '&:disabled': {
          color: colors.grass90,
        },
      },
    },
  ],
};
